import request from "@/untils/request.js"

export const addPatternPayment = (data) => {
    return request.post("/outpatient/user/payway", data)
}

export const editPatternPayment = (data) => {
    return request.put("/outpatient/user/payway", data)
}

export const getPatternPaymentPage = (params) => {
    return request.get("/outpatient/user/payway/page", {params})
}

export const getPatternPaymentList = (params) => {
    return request.get("/outpatient/user/payway/list", {params})
}

export const getPatternPaymentById = (id) => {
    return request.get(`/outpatient/user/payway/${id}`)
}
